var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('VideoSwiper',{attrs:{"video-list":_vm.videoList,"is-ios":_vm.isIos},on:{"load-more":_vm.handleLoadMore,"refresh":_vm.handleRefresh}}),_vm._v(" "),(_vm.guideShow && !_vm.isIos)?_c('div',{staticClass:"guide-box"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }